import { createContext } from 'react';
import { PageContextValue } from '../../../core/type';
import { Item, ItemEntry } from '../type';

export const ItemPageContext = createContext<PageContextValue<Item, ItemEntry>>({})
